import React from "react";
import Search from "../../images/search.svg";
import "./PayrollAdminTableFilterHeader.scss"; // Copy styles from AdminTableFilterHeader.scss
import { Box, Button, Typography, TextField } from "@mui/material";

function PayrollAdminTableFilterHeader({ setSearchText, handleOpen, searchText }) {
  const handleInputChange = (event) => {
    const inputText = event.target.value;
    setSearchText(inputText);
  };

  return (
    <Box className="options-container">
      <Box className="search-container">
        <TextField
          placeholder="Search Payroll Admin"  // Updated placeholder for context
          value={searchText}
          onChange={handleInputChange}
          variant="standard"
          fullWidth
          InputProps={{
            disableUnderline: true,
            sx: {
              borderRadius: '33px',
              color: '#000',
            },
            endAdornment: (
              <img
                src={Search}
                alt="Search Icon"
                style={{ paddingLeft: '5px' }}
                loading="lazy"
              />
            ),
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '14px',
            },
          }}
        />
      </Box>

      <Button
        className="new-user-button"
        onClick={handleOpen}
        sx={{
          borderRadius: "33px",
          background: "#3bc97b",
          border: "none",
          display: "flex",
          color: "white",
          alignItems: "center",
          padding: "0px 17px 0px 25px",
          height: "40px",
          '&:hover': {
            background: "#35b06c",
          },
        }}
      >
        <Typography>Add New</Typography>
        <Box>+</Box>
      </Button>
    </Box>
  );
}

export default PayrollAdminTableFilterHeader;